import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { UserPreferencesEditState } from '../interfaces/userPreferences.interface';

const initialState: UserPreferencesEditState = {
  userAvatarUrl: null,
  userAvatarKey: null,
  isChangingAvatar: false,
  isEditingAvatar: false,
  reloadAvatar: false,
  uploading: false,
  openPreferencesView: false,
  loadingAvatar: false,
  newAvatar: null,
  newAvatarUrl: null,
};

export const userAvatarSlice = createSlice({
  name: 'userAvatarStore',
  initialState,
  reducers: {
    SET_USER_AVATAR_URL: (state, action: PayloadAction<string | null>) => {
      state.userAvatarUrl = action.payload;
    },
    SET_NEW_AVATAR_URL: (state, action: PayloadAction<string | null>) => {
      state.newAvatarUrl = action.payload;
    },
    SET_USER_AVATAR_KEY: (state, action: PayloadAction<string | null>) => {
      state.userAvatarKey = action.payload;
    },
    SET_IS_CHANGING_AVATAR: (state, action: PayloadAction<boolean>) => {
      state.isChangingAvatar = action.payload;
    },
    SET_IS_EDITING_AVATAR: (state, action: PayloadAction<boolean>) => {
      state.isEditingAvatar = action.payload;
    },
    SET_RELOAD_AVATAR: (state, action: PayloadAction<boolean>) => {
      state.reloadAvatar = action.payload;
    },
    SET_LOADING_AVATAR: (state, action: PayloadAction<boolean>) => {
      state.loadingAvatar = action.payload;
    },
    SET_UPLOADING: (state, action: PayloadAction<boolean>) => {
      state.uploading = action.payload;
    },
    SET_OPEN_PREFERENCES_VIEW: (state, action: PayloadAction<boolean>) => {
      state.reloadAvatar = action.payload;
    },
    SET_NEW_AVATAR: (state, action: PayloadAction<string | null>) => {
      state.newAvatar = action.payload;
    },
    SET_UPLOAD_RESPONSE_AVATAR: (
      state,
      action: PayloadAction<string | null>,
    ) => {
      state.newAvatar = action.payload;
    },
  },
});

export const {
  SET_USER_AVATAR_URL,
  SET_USER_AVATAR_KEY,
  SET_IS_CHANGING_AVATAR,
  SET_IS_EDITING_AVATAR,
  SET_RELOAD_AVATAR,
  SET_UPLOADING,
  SET_LOADING_AVATAR,
  SET_NEW_AVATAR,
  SET_UPLOAD_RESPONSE_AVATAR,
} = userAvatarSlice.actions;

export default userAvatarSlice.reducer;
